import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

@Injectable({
  providedIn: 'root',
})

export class ImageStorageService {
  private dbPromise: Promise<IDBPDatabase>;

  constructor() {
    this.dbPromise = this.initDB();
  }

  private async initDB() {
    return await openDB('image-store', 1, {
      upgrade(db) {
        db.createObjectStore('images');
      },
    });
  }

  async storeImage(key: string, blob: Blob) {
    const db = await this.dbPromise;
    await db.put('images', blob, key);
  }

  async getImage(key: string): Promise<Blob | undefined> {
    const db = await this.dbPromise;
    return await db.get('images', key);
  }

  async deleteImage(key: string) {
    const db = await this.dbPromise;
    await db.delete('images', key);
  }

  async clearAllimages() {
    const db = await this.dbPromise;
    await db.clear('images');
  }

  async getAllKeys(): Promise<IDBValidKey> {
    const db = await this.dbPromise;
    return await db.getAllKeys('images');
  }
}
